import React, {useEffect} from 'react';
import InputDateTime from "../../../../components/input/input-datetime.jsx";
import SelectComponent from "../../../../components/select/select-component.jsx";
import {useQuery} from "@tanstack/react-query";
import Loader from "../../../../components/template/loader.jsx";
import {useGeneralInputSpecialCase} from "../../../../hooks/use-general-input.js";
import {statusObjArr} from "../utils/utils.js";
import sosXrayService from "../../../../services/reports/sos-xray-service.js";
import {minMenuHeight} from "../../../../components/reports/report-menu/menu.jsx";

const Filters = ({ setFilters, filters }) => {
  const handleInput = useGeneralInputSpecialCase(setFilters);

  const {data: protectionTypes = []} = useQuery({
    queryFn: sosXrayService.getAllProtectionProgram,
    queryKey: ['protectionTypes']
  })

  const {data: providences = []} = useQuery({
    queryFn: sosXrayService.getAllEventProvidences,
    queryKey: ['providences']
  })

  return (
    <>
      <div className={`mb-2 ${minMenuHeight}`}>
        <form className={'space-y-4'}>

          <InputDateTime
              id="dtStart"
              label="Data/hora inicial *"
              selected={filters.dtStart}
              onChange={(date) => handleInput('dtStart', date)}
              classNameWrapper={"w-full"}
              dateFormat="LL"
          />

          <InputDateTime
              id="dtEnd"
              label="Data/hora final *"
              selected={filters.dtEnd}
              onChange={(date) => handleInput('dtEnd', date)}
              classNameWrapper={"w-full"}
              dateFormat="LL"
          />

          <SelectComponent
              id="analysis"
              label='Tipo de análise *'
              isMulti={false}
              wrapValues={true}
              options={[
                {label: "Cadastros", value: 'register'},
                {label: "Acionamentos", value: 'event'}
              ]}
              value={filters.analysis}
              onChange={(value) => setFilters(prev => ({...prev, analysis: value}))}
              classNameWrapper={"w-full"}
              isClearable={false}
          />

          <SelectComponent
              instanceId="status"
              id="status"
              label="Status"
              options={statusObjArr}
              isMulti
              value={statusObjArr.filter(el => filters.status.map(item => item.value).includes(el.value))}
              onChange={selected => handleInput("status", selected)}
          />

          <SelectComponent
              instanceId="protectionType"
              id="protectionType"
              label="Programa de proteção"
              options={protectionTypes}
              isMulti
              value={protectionTypes.filter(el => filters.protectionType.map(item => item.value).includes(el.value))}
              onChange={selected => handleInput("protectionType", selected)}
          />

          <SelectComponent
              instanceId="providence"
              id="providence"
              label="Providência após acionamento"
              options={providences}
              isMulti
              wrapValues={true}
              value={providences.filter(el => filters.providence.map(item => item.value).includes(el.value))}
              onChange={selected => handleInput("providence", selected)}
              isDisabled={filters?.analysis?.value === 'register'}
          />

        </form>
      </div>
    </>
  );
};

export default Filters;